/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const myInternshipV4Schema = z
  .object({
    internId: z
      .string()
      .default('')
      .describe('Intern id (coded) — identifies this internship context when switching.')
      .meta({ examples: ['kJ8v2Qm7xR1a'] }),
    name: z.string().min(1).default('').describe('Internship title.'),
    start: z
      .string()
      .min(1)
      .default('')
      .describe('Start date, yyyy-MM-dd (Intern.Start ?? Internship.Start).'),
    end: z
      .string()
      .min(1)
      .default('')
      .describe('End date, yyyy-MM-dd (Intern.End ?? Internship.End).'),
    isCurrent: z
      .boolean()
      .default(false)
      .describe('True when the active token context is this internship.'),
  })
  .describe("One internship of the user within a STUDENT entry's EDU org — a switch target.")
